import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import LayoutView from 'components/shared/layout/view'
import { useHistory } from 'react-router-dom'
import { getQueryString } from 'utils/queryString'
import Navigation from './navigation'
import Header from './header'
import componentObj from './dataset'
import SwitchableContent from './switcahble-content'

const Bookings = ({ loading }) => {
  const history = useHistory()
  const query = getQueryString(history.location.search)
  const [selectedComponent, setSelectedComponent] = useState('requests') // i could pass here via match state
  const RenderComponent = componentObj.find(({ value }) => value === selectedComponent).component

  useEffect(() => {
    if (query.view) setSelectedComponent(query.view)
  }, [query.view]);
  return (
    <LayoutView theme="grey" customClass="" loading={loading}>
      <SwitchableContent>
        {handleSwitchContent => (
          <div className="bg-white md:my-10 w-full md:w-11/12 shadow-md md:rounded-lg m-auto">
            <Navigation selected={selectedComponent} onClick={value => history.push(`/client?view=${value}`)} />
            <div className="my-5">
              <Header selected={selectedComponent} />
              <RenderComponent handleSwitchContent={handleSwitchContent} />
            </div>
          </div>
        )}
      </SwitchableContent>
    </LayoutView>
  )
}

Bookings.propTypes = {
  loading: PropTypes.bool.isRequired,
}

const mapStateToProps = ({ bookings }) => ({
  loading: bookings.fetching,
})

export default connect(mapStateToProps)(Bookings)
